export const AUTH_PATTERN =
  /^\/(login|requestAccess|createAccount|resetPassword|networks|forgotPassword|message|emailConfirmed)(\/|$)/i
export const DONATE_PATTERN = /^\/donate(?:\/|$)/i
